function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function setAccordionContentHeight(details) {
  const content = details.querySelector('.accordion__content');
  if (!content) return;
  content.style.setProperty('--accordion-content-height', `${content.scrollHeight}px`);
}

function clearAccordionAnimationState(details) {
  details.classList.remove('is-opening', 'is-closing', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (content) {
    content.style.removeProperty('--accordion-content-height');
    content.style.height = '';
  }
}

function scrollAccordionToReveal(details, summary) {
  if (!details || !summary) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const content = details.querySelector('.accordion__content');
  const rect = summary.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const padding = 200;
  let targetTop = window.scrollY + rect.top - padding;

  if (content) {
    const contentHeight = content.scrollHeight;
    if (contentHeight + padding * 2 <= viewportHeight) {
      const bottomVisible = rect.top + contentHeight + padding <= viewportHeight;
      if (!bottomVisible) {
        targetTop = window.scrollY + rect.top + contentHeight + padding - viewportHeight;
      }
    }
  }

  window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
}

function openProductAccordion(details, summary) {
  if (!details || details.classList.contains('is-animating')) return;
  details.setAttribute('open', '');
  summary.setAttribute('aria-expanded', 'true');
  setAccordionContentHeight(details);
  details.classList.remove('is-closing');
  details.classList.add('is-opening', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (!content) {
    clearAccordionAnimationState(details);
    return;
  }
  const onOpenEnd = () => {
    content.removeEventListener('animationend', onOpenEnd);
    content.style.height = 'auto';
    clearAccordionAnimationState(details);
    requestAnimationFrame(() => scrollAccordionToReveal(details, summary));
  };
  content.addEventListener('animationend', onOpenEnd);
}

function closeProductAccordion(details, summary) {
  if (!details || details.classList.contains('is-animating')) return;
  if (!details.hasAttribute('open')) return;
  setAccordionContentHeight(details);
  details.classList.remove('is-opening');
  details.classList.add('is-closing', 'is-animating');
  const content = details.querySelector('.accordion__content');
  if (!content) {
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    clearAccordionAnimationState(details);
    return;
  }
  const onCloseEnd = () => {
    content.removeEventListener('animationend', onCloseEnd);
    details.removeAttribute('open');
    summary.setAttribute('aria-expanded', 'false');
    clearAccordionAnimationState(details);
  };
  content.addEventListener('animationend', onCloseEnd);
}

const summaryBtns = document.querySelectorAll('[id^="Details-"] summary');

summaryBtns.forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (summary.classList.contains('header__menu-item--primary')) {
    const parent = summary.parentNode;
    const details = summary.closest('details');
    let closeTimeout;

    parent.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      details.classList.remove('is-closing'); // Remove if re-entered
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    parent.addEventListener('mouseleave', () => {
      details.classList.add('is-closing'); // Add closing class
      closeTimeout = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        details.classList.remove('is-closing'); // Remove after closing
      }, 300);
    });

    summary.addEventListener('click', e => e.preventDefault());
  } else {
    summary.addEventListener('click', (event) => {
      const isProductAccordion = summary.closest('.product__accordion');
      const currentTarget = event.currentTarget;
      const currentDetails = currentTarget.closest('details');
      const shouldOpen = !currentDetails.hasAttribute('open');

      if (isProductAccordion) {
        event.preventDefault();

        summaryBtns.forEach((summaryBtn) => {
          const ariaControls = summaryBtn.getAttribute('aria-controls');
          if (ariaControls && ariaControls.indexOf('ProductAccordion') > -1) {
            if (summaryBtn !== currentTarget) {
              const otherDetails = summaryBtn.closest('details');
              closeProductAccordion(otherDetails, summaryBtn);
            }
          }
        });

        if (shouldOpen) {
          openProductAccordion(currentDetails, currentTarget);
        } else {
          closeProductAccordion(currentDetails, currentTarget);
        }

        return;
      }

      currentTarget.setAttribute('aria-expanded', shouldOpen);

      summaryBtns.forEach((summaryBtn) => {
        if (summaryBtn.getAttribute('aria-controls').indexOf('ProductAccordion') > -1) {
          if (summaryBtn !== currentTarget) {
            summaryBtn.setAttribute('aria-expanded', false);
            summaryBtn.parentNode.removeAttribute('open');
          }
        }
      });
    });
  }

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if (!container) {
    return
  }
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.changeInProgress = false;
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    // Cart 4.0 progress bar: animate direction (fill vs. unfill) based on +/-
    if (event.target.name === 'plus') {
      document.body.classList.remove('progress-bar-qty-decrease');
    } else {
      document.body.classList.add('progress-bar-qty-decrease');
    }

    if (!this.changeInProgress) {
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      this.blockMultipleClicks(event);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  blockMultipleClicks(event) {
    this.changeInProgress = true;
    // console.log('din block click')
    if (event.target.name == 'plus') {
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', true);
      setTimeout(() => {
        this.changeInProgress = false;
        buttonPlus.classList.toggle('disabled', false);

      }, 500)
    }
    if (event.target.name == 'minus') {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', true);
      setTimeout(() => {
        this.changeInProgress = false;
        buttonMinus.classList.toggle('disabled', false);
      }, 500)
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const selectedTabMenu = detailsElement.closest('.custom-tabs__content-item');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        selectedTabMenu && selectedTabMenu.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      // Keep "always open" submenus expanded so they don't collapse on close/reopen
      if (details.classList.contains('menu-always-open')) return;
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    const selectedTabMenu = detailsElement.closest('.custom-tabs__content-item');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    selectedTabMenu && selectedTabMenu.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this, false));
    this.querySelector('[id^="ModalClose-second-"]')?.addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      this.setAttribute('open', '');
      // if (popup) popup.loadContent();
      // trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }, 250)

    if (this.querySelector('.modal-content')) {
      this.querySelector('.modal-content').classList.remove('animate-slideToBottomPopup');
      this.querySelector('.modal-content').classList.add('animate-slideFromBottomPopup');
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    setTimeout(() => {
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }, 250)

    if (this.querySelector('.modal-content')) {
      this.querySelector('.modal-content').classList.remove('animate-slideFromBottomPopup');
      this.querySelector('.modal-content').classList.add('animate-slideToBottomPopup');
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.windowSize = window.innerWidth;
    this.windowSizeScrollUpdate = 750;
    this.isMobile = this.windowSize < this.windowSizeScrollUpdate ? true : false;
    this.isHorizontal = this.slider.classList.contains('slider--horizontal') ? true : false;
    this.mobileDotsCounter = this.querySelector('.slider-counter--dots-wrapper');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  connectedCallback() {
    //runs once component is mounted in the page
    if (this.mobileDotsCounter && this.isMobile) {
      this.mobileDotsInit();
    }
  }

  initPages() {
    if (this.isHorizontal) {
      // calculations for Horizontal slider 
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    } else {
      //calculations for Vertical slider
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;

    if (this.isHorizontal) {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisibleX(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisibleX(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

    } else {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisibleY(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisibleY(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    //call dots update
    if (this.currentPage != previousPage) {
      //update dots
      if (this.mobileDotsCounter) {
        if (this.isMobile) {
          this.updateMobileDots(this.currentPage)
        }
      }
      //end

      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    //to hide products tags in PDP on infographic image
    if (this.currentPage == 2) { //used to becasuse the infograpgic image is on the second slide
      document.querySelector('.product__gallery-slider').classList.add('hide-gallery-tags')
    }
    else {
      document.querySelector('.product__gallery-slider').classList.remove('hide-gallery-tags')
    }
  }

  isSlideVisibleY(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  isSlideVisibleX(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element?.offsetLeft + element?.clientWidth <= lastVisibleSlide && element?.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (this.isHorizontal) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.isHorizontal) {
      this.slider.scrollTo({
        left: position,
      });
    }
    else {
      this.slider.scrollTo({
        top: position,
      });
    }
  }

  mobileDotsInit() {
    //add dots to component
    const slider = this.mobileDotsCounter.querySelector('.slider-counter--dots');
    slider.innerHTML = ``;
    this.sliderItemsToShow.forEach((item, index) => {
      if (index == 0) {
        slider.innerHTML += `<div class="dot active" data-index="${index}"></div>`;
      }
      else {
        slider.innerHTML += `<div class="dot" data-index="${index}"></div>`;
      }
    })
  }

  updateMobileDots(currentPage = 0) {
    const slider = this.mobileDotsCounter.querySelector('.slider-counter--dots');
    const target = slider.querySelector(`.dot[data-index="${currentPage - 1}"]`)
    if (!slider || !target) return;

    // Get the target element's offset relative to the container
    const containerScrollLeft = target.offsetLeft - slider.offsetLeft;

    slider.querySelectorAll('.dot').forEach((el) => {
      if (el.dataset.index == currentPage - 1) {
        el.classList.add('active')
      }
      else {
        el.classList.remove('active')
      }
    })

    //check if scroll is needed _
    const sliderRect = slider.getBoundingClientRect();
    const dotRect = target.getBoundingClientRect();

    if (dotRect.left < sliderRect.left || dotRect.right > sliderRect.right) {
      // Scroll the slider to bring the active dot into view
      slider.scrollTo({
        left: containerScrollLeft,
        behavior: 'smooth'
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollTop + this.sliderFirstItemNode.clientHeight * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollTop + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollTop +
      this.sliderFirstItemNode.clientHeight *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// New DS Animated Modal Popup - 5/9/2023
class AnimatedModalButton extends HTMLElement {
  constructor() {
    super();
    this.bisButtonClass = 'js-back-in-stock';
    this.bisModalProductTitleClass = 'back-in-stock__product-title';
    this.bisModalProductVendorClass = 'back-in-stock__product-vendor';
    this.bisModalFormEmailInput = 'back-in-stock__form input[type="email"]';
    this.bisModalFormButton = 'back-in-stock__form button';
    this.bisModalErrorMessage = 'back-in-stock__form-error-message';
    this.bisModalSuccessMessage = 'back-in-stock__form-success-message';
    this.modalToggleClass = 'show';
    this.button = this.querySelector('button');
    this.toggleModalHandler();
  }

  toggleModalHandler() {
    this.button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const modalTargetAttribute = button.dataset.modalTarget;
      const modal = document.querySelector(modalTargetAttribute);

      if (modal) {
        this.toggleModal(modal);
        this.updateBackInStockModal(button, modal);
      }
    });
  }

  updateBackInStockModal(button, modal) {
    if (button.classList.contains(this.bisButtonClass)) {
      const variantId = button.dataset.variantId;
      const productTitle = button.dataset.productTitle;
      const productVendor = button.dataset.productVendor;

      const modalProductTitle = modal.querySelector('.' + this.bisModalProductTitleClass);
      const modalProductVendor = modal.querySelector('.' + this.bisModalProductVendorClass);
      const modalFormEmailInput = modal.querySelector('.' + this.bisModalFormEmailInput);
      const modalFormButton = modal.querySelector('.' + this.bisModalFormButton);
      const modalSuccessMessage = modal.querySelector('.' + this.bisModalSuccessMessage);
      const modalErrorMessage = modal.querySelector('.' + this.bisModalErrorMessage);

      if (productTitle) {
        modalProductTitle.innerHTML = productTitle;
      }

      if (productVendor) {
        modalProductVendor.innerHTML = productVendor;
      }

      if (variantId) {
        modalFormButton.setAttribute('data-variant-id', variantId);
      }

      //Reset Modal Form
      modalFormEmailInput.classList.remove('error');
      modalSuccessMessage.classList.add('hidden');
      modalErrorMessage.classList.add('hidden');
      modal.querySelector('.back-in-stock__form').classList.remove('hidden')
    }
  }

  toggleModal(modal) {
    modal.classList.toggle(this.modalToggleClass);
    // console.log('modal open!!')
    let animatedEl = modal.querySelector('.animate-slideToBottomPopup')
    if (animatedEl) {
      animatedEl.classList.remove('animate-slideToBottomPopup');
      animatedEl.classList.add('animate-slideFromBottomPopup');
    }
  }
}

customElements.define('ds-button', AnimatedModalButton);

class AnimatedModalPopup extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[aria-label="Close"]');
    this.modalContent = this.querySelector('.ds-modal__content');
    this.init();
  }

  init() {
    this.closeModalHandler();
    this.outsideClickHandler();
  }

  closeModalHandler() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        console.log('modal close!!')
        if (this.closeButton.closest('.animate-slideFromBottomPopup')) {
          let el = event.target.closest('.animate-slideFromBottomPopup');
          el.classList.remove('animate-slideFromBottomPopup')
          el.classList.add('animate-slideToBottomPopup');
        }
        setTimeout(() => {
          this.classList.remove('show');

          if (this.modalContent.closest('#free-product-modal-gift')) {
            document.querySelector('#free-product-modal-gift').classList.remove('step-1');
            document.querySelector('#free-product-modal-gift').classList.add('step-2');
          }
        }, 500)
      });
    }
  }

  outsideClickHandler() {
    this.addEventListener('click', (event) => {
      if (this.modalContent && !this.modalContent.contains(event.target)) {

        if (this.querySelector('.animate-slideFromBottomPopup')) {
          let el = this.querySelector('.animate-slideFromBottomPopup');
          el.classList.remove('animate-slideFromBottomPopup')
          el.classList.add('animate-slideToBottomPopup');
        }
        setTimeout(() => {
          this.classList.remove('show');

          if (this.modalContent.closest('#free-product-modal-gift')) {
            document.querySelector('#free-product-modal-gift').classList.remove('step-1');
            document.querySelector('#free-product-modal-gift').classList.add('step-2');
          }
        }, 500)
      }
    });
  }
}

customElements.define('ds-modal', AnimatedModalPopup);

function updateCartCountBubbleBottomIsland() {
  if (!document.querySelector('[data-cart-qty]')) return;

  let quantity = document.querySelector('[data-cart-qty]').dataset.cartQty;
  document.querySelector('#bottom-island-cart-count-buble .cart-count-bubble').dataset.items = quantity;
  document.querySelector('#bottom-island-cart-count-buble .cart-count-bubble').innerHTML = `
    <span aria-hidden="true">${quantity}</span>
    <span class="visually-hidden">${quantity} items</span>`
}

// Update add to cart buttons if the cart limit is reached
function cartLimitReached(cartQty) {
  // console.log('@---> din cart limit')
  let cartQuantityNumber = 0;

  if (document.querySelector('[data-cart-qty]')) {
    cartQuantityNumber = parseInt(document.querySelector('[data-cart-qty]').dataset.cartQty) ? parseInt(document.querySelector('[data-cart-qty]').dataset.cartQty) : 0;
  }

  const selectors = ['.quick-add__submit', '.product-form__submit', '.product-layering__add-to-cart'];
  const quantityPlusButton = document.querySelectorAll('.quantity__button[name="plus"]');
  const skipBisSelector = 'js-back-in-stock';

  const disableAddToCartBtn = (button) => {
    if (button.querySelector('span')) {
      if (button.querySelector('.atc-text')) {
        button.querySelector('.atc-text').innerHTML = cartProductsLimitText;
      }
      else {
        if (button.querySelector('.btn-added-checkmark')) {
          setTimeout(() => {
            button.querySelector('span').innerHTML = cartProductsLimitText;
            // console.log('atc text change thin cart limit')
          }, 4000)
        }
        else {

          button.querySelector('span').innerHTML = cartProductsLimitText;
        }
      }
      button.setAttribute('disabled', '');
    }
  };

  const enableAddToCartBtn = (button, addToCartText) => {
    if (button.querySelector('span')) {
      if (button.querySelector('.atc-text')) {
        button.querySelector('.atc-text').innerHTML = addToCartText || productAddText;
      }
      else {
        if (button.querySelector('.btn-added-checkmark')) {
          setTimeout(() => {
            button.querySelector('span').innerHTML = addToCartText || productAddText;
            // console.log('atc text change thin cart limit')
          }, 4000)
        }
        else {
          button.querySelector('span').innerHTML = addToCartText || productAddText;
        }
      }
      button.removeAttribute('disabled');
    }
  };

  const setButtonsState = (disable) => {
    for (const selector of selectors) {
      const buttons = document.querySelectorAll(selector);
      if (buttons) {
        buttons.forEach((button) => {
          if (button) {
            if (!button.classList.contains(skipBisSelector)) {
              if (disable) {
                disableAddToCartBtn(button);
              } else {
                if (button.getAttribute('data-btn-text')) {
                  const addToCartText = button.dataset.btnText;
                  enableAddToCartBtn(button, addToCartText);
                } else {
                  enableAddToCartBtn(button);
                }
              }
            }
          }
        });
      }
    }
    updateCartCountBubbleBottomIsland(cartQuantityNumber);
  };

  if (cartQuantityNumber >= cartProductsLimit || cartQty >= cartProductsLimit) {
    setButtonsState(true);
    if (quantityPlusButton) {
      quantityPlusButton.forEach((button) => {
        button.classList.add('disabled');
        button.setAttribute('disabled', '');
      });
    }
  } else {
    setButtonsState(false);
    if (quantityPlusButton) {
      quantityPlusButton.forEach((button) => {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      });
    }
  }
}

// Add Multiple Items/Scents to Cart
add_multiple_scents = (event, productVariantIds) => {
  const eventTarget = event.currentTarget;

  const cartButtonEl = document.getElementById('cart-icon-bubble');
  let cartButtonCountEl = cartButtonEl.querySelector('.cart-count-bubble');
  const countCartItemsData = cartButtonCountEl.dataset.items;

  removeCartLimit = () => {
    const cartLimitTextEl = document.getElementsByClassName('productLimit__cart-limit-text');

    if (cartLimitTextEl && cartLimitTextEl.length > 0) {
      for (var i = 0; i < cartLimitTextEl.length; i++) {
        cartLimitTextEl[i].remove();
      }
    }
  }

  addToCartLoading = () => {
    eventTarget.classList.toggle('loading');
    eventTarget.querySelector('.loading-overlay__spinner').classList.toggle('hidden');
  }

  if (cartButtonEl && countCartItemsData) {
    if (parseInt(countCartItemsData) >= parseInt(cartProductsLimit) - 1) {
      removeCartLimit();

      const cartLimitTextEl = document.createElement('p');
      cartLimitTextEl.classList.add('productLimit__cart-limit-text');
      cartLimitTextEl.innerHTML = 'Cart will be overlimit. Remove 1 item from cart.';

      const itemContent = eventTarget.parentElement.parentElement;
      itemContent.parentNode.insertBefore(cartLimitTextEl, itemContent.nextSibling);
    } else {
      removeCartLimit();

      addToCartLoading();

      const items = [];
      let qty = 1;

      let itemVariantIds = productVariantIds.split(',');

      if (itemVariantIds.length == 1) {
        qty = 3;
      }

      itemVariantIds.forEach(variantId => {
        var itemVariantId = { quantity: qty, id: variantId };
        itemVariantId.properties = { '_dsrDiscounts': 'back_to_school' };
        items.push(itemVariantId);
      });

      const data = {
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
        // attributes: document.cookie.indexOf('hiddenSale=true') !== -1 || document.cookie.indexOf('crmOffer=true') !== -1 ? { dsrDiscounts: 'true' } : {}
        attributes: document.cookie.indexOf('hiddenSale=true') !== -1 ? { dsrDiscounts: 'true' } : {}
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => {
          return response.json();
        })
        .then(response => {
          // rerender cart based on fetch response
          document.querySelector('cart-drawer').renderContents(response, false, itemVariantIds);
        })
        .finally(() => {
          if (document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
          eventTarget.classList.remove('loading');
          eventTarget.querySelector('.loading-overlay__spinner').classList.add('hidden');

          //update announcement bar
          updateAnnouncementBar();
          if (typeof replayCartProgressBars === 'function') replayCartProgressBars();
          updateCartCountBubbleBottomIsland()

          updateFreeShipping()

          // Update add to cart buttons if the cart limit is reached
          cartLimitReached();

          if (window.innerWidth < 768) {

            let oldInnerHTMLOfButton = eventTarget.innerHTML;
            // add added message to button
            eventTarget.innerHTML += `
              <img class='btn-added-checkmark' src='https://cdn.shopify.com/s/files/1/0646/3304/5218/files/checkmark_white_transparent_bg.svg?v=1763482118' alt='checkmark'></img>
            `
            eventTarget.querySelector('span').innerHTML = window.Shopify.locale == 'fr' ? 'ajouté ' : 'ADDED'

            setTimeout(() => {
              if (document.querySelector('[data-cart-qty]').dataset.cartQty == '9') {
                eventTarget.innerHTML = oldInnerHTMLOfButton;
                eventTarget.querySelector('span').innerHTML = cartProductsLimitText;
              }
              else {
                eventTarget.innerHTML = oldInnerHTMLOfButton;
              }
            }, 4000)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
}


// Replay the fill animation on the cart / drawer progress bars after they get
// re-rendered on a cart change. The re-rendered .progress-bar-v3__container is a
// fresh element already at its final width, so the CSS transition won't fire; we
// force it to the previous qty (no-anim), reflow, then set the new qty so the
// line width, pill colors and free-shipping icon animate old -> new.
// (Announcement bar handles its own replay inside updateAnnouncementBar.)
window._progressQtyCache = window._progressQtyCache || {};
function replayCartProgressBars() {
  document.querySelectorAll('.progress-bar-v3__container').forEach((container) => {
    if (container.closest('.announcement-bar-section')) return; // announcement replays itself
    const key = container.closest('cart-drawer') ? 'drawer' : 'cartpage';
    const newQty = container.getAttribute('data-qty');
    const oldQty = window._progressQtyCache[key];
    window._progressQtyCache[key] = newQty;
    if (oldQty != null && oldQty !== newQty) {
      container.classList.add('no-progress-anim');
      container.setAttribute('data-qty', oldQty);
      void container.offsetWidth; // lock the old state without transition
      container.classList.remove('no-progress-anim');
      container.setAttribute('data-qty', newQty); // transitions now fire old -> new
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  // seed the cache with the initial qty so the FIRST cart change already animates
  document.querySelectorAll('.progress-bar-v3__container').forEach((container) => {
    if (container.closest('.announcement-bar-section')) return;
    const key = container.closest('cart-drawer') ? 'drawer' : 'cartpage';
    window._progressQtyCache[key] = container.getAttribute('data-qty');
  });
});

// update announcement bar
function updateAnnouncementBar() {
  //update announcement bar progress bar
  //updates the announcement bar using the shopify rendering api
  let announcementBarContainer = document.querySelector('.announcement-bar-section');

  if (announcementBarContainer) {
    let section_id = announcementBarContainer.id.replace('shopify-section-', '')
    fetch(`${window.Shopify.routes.root}?section_id=${section_id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // capture previous progress state (qty) before the container gets replaced below,
        // so the progress bar (line width + pill colors + free-shipping icon) animates from old -> new.
        // Scope to the announcement bar — cart 4.0 added other .progress-bar-v3__container
        // elements (drawer / cart page), so a document-wide query could grab the wrong one.
        const oldContainer = announcementBarContainer.querySelector('.progress-bar-v3__container');
        const oldQty = oldContainer ? oldContainer.getAttribute('data-qty') : null;

        const selectors = ['.promo-announcement-bar-container'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
            // document.querySelector('.announcement-bar-section .promo-announcement-bar_left-side').classList.remove('show');
          }
        }

        // replay the transition from the previous qty to the new one (works both ways)
        const newContainer = announcementBarContainer.querySelector('.progress-bar-v3__container');
        if (newContainer && oldQty !== null) {
          const newQty = newContainer.getAttribute('data-qty');
          if (oldQty !== newQty) {
            newContainer.classList.add('no-progress-anim');
            newContainer.setAttribute('data-qty', oldQty);
            void newContainer.offsetWidth; // force reflow to lock the old state with no transition
            newContainer.classList.remove('no-progress-anim');
            newContainer.setAttribute('data-qty', newQty); // transitions now fire old -> new
          }
        }

        updateFreeShipping();

      })
      .finally(() => {
        document.dispatchEvent(new CustomEvent('announcement-bar:updated'));

        if (document.cookie.indexOf('hiddenSale=true') !== -1) {
          // SS: swap based on cart qty
          if (document.querySelector('[data-cart-qty]')?.dataset.cartQty != '0') {
            announcementBarContainer.querySelector('.announcement__progress-bar').classList.add('show');
            announcementBarContainer.querySelector('.delivery-cut-off-container').classList.remove('show');

            if (window.innerWidth < 1024) {
              document.querySelector('.top-bar_arrow-left_container').style.display = 'flex';
              document.querySelector('.top-bar_arrow-right_container').style.display = 'flex';
            } else {
              document.querySelector('.top-bar_arrow-left_container').style.display = 'none';
              document.querySelector('.top-bar_arrow-right_container').style.display = 'none';
            }

            clearInterval(swithTopBarMassagesInterval);
            swithTopBarMassagesInterval = setInterval(function () {
              let messageOne = announcementBarContainer.querySelector('.announcement__progress-bar');
              let messageTwo = announcementBarContainer.querySelector('.delivery-cut-off-container');
              if (messageOne.classList.contains('show')) {
                messageOne.classList.remove('show');
                messageTwo.classList.add('show');
              } else if (messageTwo.classList.contains('show')) {
                messageOne.classList.add('show');
                messageTwo.classList.remove('show');
              }
            }, 7000);
          } else {
            clearInterval(swithTopBarMassagesInterval);
            announcementBarContainer.querySelector('.delivery-cut-off-container').classList.remove('show');
            document.querySelector('.top-bar_arrow-left_container').style.display = 'none';
            document.querySelector('.top-bar_arrow-right_container').style.display = 'none';
          }
        } else {
          // BMSM default
          if (document.querySelector('[data-cart-qty]')?.dataset.cartQty != '0') {
            clearInterval(swithTopBarMassagesInterval);
            announcementBarContainer.querySelector('.announcement__progress-bar').classList.add('show');
            announcementBarContainer.querySelector('.delivery-cut-off-container').classList.remove('show');
          } else {
            let deliveryCutOffMsgEl = document.querySelector('.delivery-cut-off-msg');
            if (!deliveryCutOffMsgEl || deliveryCutOffMsgEl.innerHTML.trim() === '') {
              announcementBarContainer.querySelector('.announcement__progress-bar').classList.add('show');
              announcementBarContainer.querySelector('.delivery-cut-off-container').classList.remove('show');
              return;
            }

            swithTopBarMassagesInterval = setInterval(function () {
              if (window.innerWidth < 1024) {
                let messageOne = announcementBarContainer.querySelector('.announcement__progress-bar');
                let messageTwo = announcementBarContainer.querySelector('.delivery-cut-off-container');
                if (announcementBarContainer.querySelector('.promo-announcement-bar').classList.contains('user_already_registered')) {
                  messageOne.classList.add('show');
                  messageTwo.classList.remove('show');
                } else {
                  if (messageOne.classList.contains('show')) {
                    messageOne.classList.remove('show');
                    messageTwo.classList.add('show');
                  } else if (messageTwo.classList.contains('show')) {
                    messageOne.classList.add('show');
                    messageTwo.classList.remove('show');
                  }
                }
              }
            }, 7000);
          }
        }
      }
      )

  }
}

// bundle builder update
async function updateBundleBuilder() {

  // use section rendering API to render bundle list

  if (!document.querySelector('.bundle-builder')) {
    return;
  }

  let sectionId = document.querySelector('.bundle-builder .shopify-section').id.replace('shopify-section-', '')

  let fetchUrl = `${window.Shopify.routes.root}?section_id=${sectionId}`
  let resultFetch = await fetch(fetchUrl);
  let result = await resultFetch.text()

  //update html
  document.querySelector('.bundle-builder__item-list-wrapper').innerHTML = new DOMParser().parseFromString(result, 'text/html').querySelector('.bundle-builder__item-list-wrapper').innerHTML;


  function bundleBuilderScrollInit() {
    //logic for bundle builder arrows scroll

    let leftArrow = document.querySelector('.bundle-builder__item-list-body_arrow.arrow-left');
    let rightArrow = document.querySelector('.bundle-builder__item-list-body_arrow.arrow-right');
    let listContainer = document.querySelector('.bundle-builder__item-list-body-container');
    let listWrapper = document.querySelector('.bundle-builder__item-list-body-wrapper');

    function updateScrollIndicators() {
      const { scrollLeft, scrollWidth, clientWidth } = listWrapper;

      if (scrollLeft > 0) {
        leftArrow.classList.add('show')
      }
      else {
        leftArrow.classList.remove('show')
      }

      if (scrollLeft < scrollWidth - clientWidth) {
        rightArrow.classList.add('show')
      }
      else {
        rightArrow.classList.remove('show')
      }
    }

    listWrapper.addEventListener('scroll', updateScrollIndicators);

    // Initial check for scroll indicators
    updateScrollIndicators();

    // Scroll on indicator click
    listContainer.addEventListener('click', (e) => {

      if (e.target.closest('.bundle-builder__item-list-body_arrow.arrow-left')) {
        listWrapper.scrollBy({ left: -150, behavior: 'smooth' });
      }

      if (e.target.closest('.bundle-builder__item-list-body_arrow.arrow-right')) {
        listWrapper.scrollBy({ left: 150, behavior: 'smooth' });
      }
    })
  }

  bundleBuilderScrollInit();
}
// END bundle builder update


// Helper functions for working with cookies
function setCookie(name, value) {
  document.cookie = `${name}=${value};path=/`;
}

function getCookie(name) {
  var cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return cookieValue ? cookieValue.pop() : null;
}

// Custom Tabs Functionality - Including BlazerSlider
function initializeCustomTabs() {
  const customTabsMenuItem = document.querySelectorAll('.custom-tabs__menu-item');
  const activeClass = 'active';

  customTabsMenuItem.forEach((tabItem) => {
    tabItem.addEventListener('click', function () {
      if (this.classList.contains(activeClass)) return;

      const customTabs = this.closest('.custom-tabs');

      // Remove current active class
      const prevTabItem = this.parentElement.querySelector('.' + activeClass);
      if (prevTabItem) {
        const prevTabId = prevTabItem.dataset.collection;
        const prevTabContent = customTabs.querySelector(`#custom-tabs__slide-item-${prevTabId}`);
        prevTabItem.classList.remove(activeClass);
        prevTabContent.classList.remove(activeClass);
      }

      // Activate the current clicked tab menu item
      this.classList.add(activeClass);

      const currentTabId = this.dataset.collection;
      const currentTab = customTabs.querySelector(`#custom-tabs__slide-item-${currentTabId}`);
      if (currentTab) currentTab.classList.add(activeClass);

      // Initialize the slider if it exists and is not yet initialized
      const slider = customTabs.querySelector('.blaze-slider--bestSellers.active');
      if (slider && !slider.classList.contains('slider-initialized')) {
        initializeSlider(slider);
      }

      // Menu Drawer - Close Submenu
      const menuDrawerOpen = document.querySelector('.menu-drawer__menu.submenu-open');
      if (menuDrawerOpen) {
        MenuDrawer.prototype.closeSubmenu(menuDrawerOpen.querySelector('details[open]'));
      }
    });
  });
}

initializeCustomTabs();

// Search ToolTip - Show + Hide after 5s
class SearchToolTip {
  constructor() {
    this.bindSearchTooltip();
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // days * hours * minutes * seconds * milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  toggleSearchTooltip(tooltips, show) {
    tooltips.forEach((tooltip) => {
      if (show) {
        tooltip.classList.add('show');

        const closeButton = tooltip.querySelector('.header-search-tooltip__close');
        if (closeButton) {
          closeButton.addEventListener('click', (event) => {
            const searchToolTip = event.target.closest('.header-search-tooltip');
            if (searchToolTip) {
              searchToolTip.classList.remove('show');
            }
          });
        }
      } else {
        tooltip.classList.remove('show');
      }
    });
  }

  bindSearchTooltip() {
    const searchTooltipViewed = this.getCookie('searchTooltipViewed');

    if (!searchTooltipViewed) {
      const searchTooltips = document.querySelectorAll('.header-search-tooltip');

      if (searchTooltips.length > 0) {
        this.toggleSearchTooltip(searchTooltips, true);

        setTimeout(() => {
          this.toggleSearchTooltip(searchTooltips, false);
          this.setCookie('searchTooltipViewed', 'true', 1);
        }, 5000);
      }
    }
  }
}

const searchToolTip = new SearchToolTip();


//script for search drawer search icon
document.addEventListener('DOMContentLoaded', function () {
  const menuDrawerSearch = document.querySelector('.menu-drawer__search');
  if (!menuDrawerSearch) return;
  menuDrawerSearch.addEventListener('click', function () {
    document.querySelector('.menu-drawer__close-btn')?.click();
    document.querySelector('.bottom-island__content--icon.bottom-island__search-btn')?.click();
  });
});

// Open announcement bar promo popup
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('bf-popup-tooltip')) {
    event.preventDefault();
    const benefitsModal = document.querySelector('#benefits-modal');
    benefitsModal.showModal()
  }
});

document.addEventListener('click', (e) => {
  //opens buy more save more modal
  if (e.target.closest('.open-dialog-modal')) {
    e.preventDefault();
    if (document.querySelector('#benefits-modal')) {
      document.querySelector('#benefits-modal').showModal();
    }
    return;
  }

  // The "i" icon on the progress bar is a :after pseudo positioned to the right
  // of .progress-bar-v3__container (outside its box). Clicking it registers on
  // the container with clientX past its right edge → open the BMSM modal.
  const progressBar = e.target.closest('.progress-bar-v3__container');
  if (progressBar) {
    // On mobile the BTS bar's ":after" info icon is hidden (info sits next to the
    // logo instead), so don't treat clicks past the bar's right edge as that icon —
    // otherwise tapping the bar / near the arrows wrongly opens the modal.
    const afterHiddenOnMobile = progressBar.classList.contains('bts') && window.innerWidth < 1024;
    if (!afterHiddenOnMobile) {
      const rect = progressBar.getBoundingClientRect();
      if (e.clientX > rect.right && document.querySelector('#benefits-modal')) {
        document.querySelector('#benefits-modal').showModal();
      }
    }
  }
})

// activate search bar animations

window.addEventListener('DOMContentLoaded', () => {
  let menuSearchBar = document.querySelector('.header__icons-search-wrapper');

  if (menuSearchBar) {
    setTimeout(() => {
      if (!menuSearchBar.classList.contains('no-animation')) { menuSearchBar.classList.add('activate-animation'); }
    }, 1250)
  }
});

function hideLowReviewWidgets() {
  document.querySelectorAll('.yotpo-widget-instance').forEach(widget => {
    const textEl = widget.querySelector('.yotpo-sr-bottom-line-text');
    if (!textEl) return;

    widget.classList.add('reviews-under');

    const reviewText = textEl.innerHTML.trim();
    const reviewNumber = parseFloat(reviewText.match(/\d+(\.\d+)?/));

    if (!isNaN(reviewNumber) && reviewNumber < 5) {
      widget.style.display = 'none';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  getCartItemsCount().then(result => {
  })
  if (window.location.pathname.includes('/products')) {
    const interval = setInterval(() => {
      const allWidgets = document.querySelectorAll('.yotpo-widget-instance');
      const readyWidgets = Array.from(allWidgets).filter(w => w.querySelector('.yotpo-sr-bottom-line-text'));

      if (readyWidgets.length > 0) {
        hideLowReviewWidgets();
      }

      // Stop when all widgets are ready
      if (allWidgets.length > 0 && readyWidgets.length === allWidgets.length) {
        clearInterval(interval);
      }
    }, 500);

    setTimeout(() => clearInterval(interval), 10000); // fail-safe
  }
});

const getCartItemsCount = () => {
  return fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(response => {
      if (!response || typeof response.total_price !== 'number') {
        throw new Error('Invalid cart data received');
      }
      return response.item_count < 3;
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
      return false;
    });
};

// Intelligems - A/B test -- UI - Free shipping for 2+ or 4+ products

function updateFreeShipping() {

  const experimentId = "5e40ea37-fd1c-4b3c-b0b6-dd0040ba483d";

  const id_version_control = "20f2010d-d629-4ba9-b459-dde2ee487d23";
  const id_version_A = "bcda7926-86f3-4768-8303-ce2549f30d8e";
  const id_version_B = "7c2ec405-9086-4ac8-913c-6249ba1146d0";

  if (typeof igData !== 'undefined' && typeof igData.user?.getTestGroup === 'function') {
    const assignedGroupId = igData?.user?.getTestGroup(experimentId)?.id;

    if (assignedGroupId !== null && assignedGroupId !== undefined) {

      if (assignedGroupId == id_version_control) {
        console.log('@------> control group')

        document.body.classList.add('ab-test__free-shipping__group-control');

      }
      if (assignedGroupId == id_version_A) {

        // 7.95 items freee shipping

        console.log('@-------> A group')

        document.body.classList.add('ab-test__free-shipping__group-A');

        if (window.location.href.includes('/products')) {
          let freeShippingElementAcordion = document.querySelector('.product__accordion-wrapper .free-shipping-price-pdp')

          if (freeShippingElementAcordion) {
            freeShippingElementAcordion.innerHTML = '<span>£7.95</span>';
          }
        }

        if (window.location.href.includes('/faq')) {
          let elements = document.querySelectorAll('.FAQ-container__title');
          elements.forEach(el => {
            if (el.innerHTML.includes('Shipping.')) {
              let actualEl = el.nextElementSibling?.nextElementSibling?.nextElementSibling.querySelector('.FAQ__a-wrapper');
              console.log('actual element', actualEl)
              actualEl.innerHTML = `
                <p>Shipping costs £7.95 if you order 1  item.</p><p>Shipping is free when you buy 2 items or more.</p>
              `
            }
          })
        }
      }
      if (assignedGroupId == id_version_B) {
        console.log('@-------> B group')

        // 3.95 shipping

        document.body.classList.add('ab-test__free-shipping__group-B');

        if (window.location.href.includes('/products')) {
          let freeShippingElementAcordion = document.querySelector('.product__accordion-wrapper .free-shipping-price-pdp')

          if (freeShippingElementAcordion) {
            freeShippingElementAcordion.innerHTML = '<span>£3.95</span>';
          }
        }

        if (window.location.href.includes('/faq')) {
          let elements = document.querySelectorAll('.FAQ-container__title');
          elements.forEach(el => {
            if (el.innerHTML.includes('Shipping.')) {
              let actualEl = el.nextElementSibling?.nextElementSibling?.nextElementSibling.querySelector('.FAQ__a-wrapper');
              console.log('actual element', actualEl)
              actualEl.innerHTML = `
                <p>Shipping costs £3.95 if you order 1  item.</p><p>Shipping is free when you buy 2 items or more.</p>
              `
            }
          })
        }
      }
    }
  }

  return;
}

// END Intelligems - A/B test -- UI - Free shipping for 2+ or 4+ products

window.addEventListener('ig:ready', () => {
  // Intelligems - A/B test: Shipping test
  updateFreeShipping();
});
window.addEventListener('DOMContentLoaded', () => {
  updateFreeShipping();
})

const dialog = document.getElementById('benefits-modal');

// open bmsm modal
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('bf-popup-tooltip') || event.target.closest('.bf-popup-tooltip')) {
    if (!dialog) return;
    event.preventDefault();

    dialog.classList.add('animate-slideFromBottomPopup');
    dialog.classList.remove('animate-slideToBottomPopup');

    dialog.showModal();
    return;
  }
});

// Close dialog popup when clicking outside
if (dialog) {
  dialog.addEventListener('click', function (event) {
    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    // Close on backdrop click OR on the Close button (which sits inside the dialog rect,
    // so the isInDialog check alone would never catch it).
    if (!isInDialog || event.target.closest('#close-dialog-modal')) {
      dialog.classList.remove('animate-slideFromBottomPopup');
      dialog.classList.add('animate-slideToBottomPopup');
      document.body.classList.remove('overflow-hidden')
      setTimeout(() => {
        dialog.close();
      }, 500)
    }
  });
}


// open lead modal from pill
document.addEventListener('click', (e) => {
  if (e.target.closest('.lead-modal_pill')) {
    if (e.target.closest('.close-icon')) {
      console.log('hiden pill')
      document.querySelector('.lead-modal_pill').classList.remove('show');
    }
    else {
      document.querySelector('.klaviyo-lead-capture-popup__container').classList.remove('animate-slideToBottomPopup');
      document.querySelector('.klaviyo-lead-capture-popup__container').classList.add('animate-slideFromBottomPopup');
      document.querySelector('.klaviyo-lead-capture-popup__wrapper').classList.add('show');
      console.log('open modal')
    }
  }
})

// END open lead modal from pill

// video pause button on CAT videos
window.addEventListener('click', (e) => {
  if (!e.target.closest('.CAT__products')) return;
  console.log('acic!!', e.target)
  if (e.target.closest('.pause-icon')) {
    let parent = e.target.closest('.promo-card-video')
    let pauseIcon = parent.querySelector('.pause-icon');
    let videos = parent.querySelectorAll('video');
    if (parent && videos.length) {
      // base the action on the real state (any video currently playing?)
      let anyPlaying = Array.from(videos).some((v) => !v.paused);
      if (anyPlaying) {
        videos.forEach((v) => v.pause());
        pauseIcon.src = 'https://cdn.shopify.com/s/files/1/0646/3304/5218/files/play-icon.svg?v=1761653577'
      } else {
        videos.forEach((v) => v.play());
        pauseIcon.src = 'https://cdn.shopify.com/s/files/1/0646/3304/5218/files/pause-icon-hp.svg?v=1761653355'
      }
    }
  }
  else {
    if (e.target.closest('.promo-card-mgk')) {
      window.location.href = `${Shopify.routes.root}products/lost-americana`
    }
    if (e.target.closest('.promo-card-it-factor')) {
      window.location.href = `${Shopify.routes.root}products/it-factor`
    }
    if (e.target.closest('.promo-card-polly-pocket')) {
      window.location.href = `${Shopify.routes.root}collections/originals#polly-pocket-collection`
    }
    if (e.target.closest('.polly-pocket-mood')) {
      window.location.href = `${Shopify.routes.root}products/marshmallow-mood`
    }
    if (e.target.closest('.polly-pocket-swirl')) {
      window.location.href = `${Shopify.routes.root}products/pistachio-swirl`
    }
    if (e.target.closest('.polly-pocket-dream')) {
      window.location.href = `${Shopify.routes.root}products/berry-daydream`
    }
  }
})

// END video pause button

// polly product cards: play the hover video on pointer enter, reset on leave
document.addEventListener('mouseover', (e) => {
  const card = e.target.closest('.product-card-wrapper');
  if (!card) return;
  const video = card.querySelector('.card__hover-video');
  if (video && video.paused) video.play().catch(() => { });
});
document.addEventListener('mouseout', (e) => {
  const card = e.target.closest('.product-card-wrapper');
  if (!card) return;
  if (e.relatedTarget && card.contains(e.relatedTarget)) return;
  const video = card.querySelector('.card__hover-video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }
});


function showDynamicPrices() {
  if (document.cookie.indexOf('hiddenSale=true') !== -1) return;

  //shows dynamic prices on product prices when qty is bigger then 2

  const getCartQuantity = () => {

    let cartQuantity = 0;

    if (document.querySelector('.cart-count-bubble')) {
      cartQuantity = document.querySelector('.cart-count-bubble').dataset.items;
    }

    return parseInt(cartQuantity);
  };

  const cartQuantity = getCartQuantity();

  if (cartQuantity >= 3) {

    let discountValue = 1;
    let discountPercent = 0;

    if (cartQuantity >= 5) {
      discountValue = 0.8; // 20% off
      discountPercent = 20;
    } else if (cartQuantity === 4) {
      discountValue = 0.85; // 15% off
      discountPercent = 15;
    } else if (cartQuantity === 3) {
      discountValue = 0.9; // 10% off
      discountPercent = 10;
    }

    // update html of prices

    const mainPriceContainers = document.querySelectorAll('.price__calculated');

    mainPriceContainers.forEach(element => {
      element.classList.remove('hidden');

      const regularPriceElement = element.querySelector('.price-item--normal-price span');
      if (regularPriceElement) {
        const regularPriceText = regularPriceElement.textContent;
        const regularPrice = parseFloat(regularPriceText.replace(/[^0-9.]/g, ''));

        const discountedPrice = regularPrice * discountValue;

        const modifiedPriceElement = element.querySelector('.first-row--price');
        if (modifiedPriceElement) {
          const formattedPrice = `$${discountedPrice.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;
          modifiedPriceElement.textContent = `£${formattedPrice.replace('$', '')}`;
        }

        const discountPercentElement = element.querySelector('.discount-percentage span');
        if (discountPercentElement) {
          discountPercentElement.textContent = discountPercent;
        }
      }
    });


    document.body.classList.add('show-dynamic-prices');
    document.body.classList.remove('hide-dynamic-prices');
  }
  else {
    document.body.classList.remove('show-dynamic-prices');
    document.body.classList.add('hide-dynamic-prices');
  }
}


document.addEventListener('DOMContentLoaded', () => {
  showDynamicPrices();

  const refreshDynamicPrices = debounce(() => {
    showDynamicPrices();
  }, 100);

  const hasDynamicPriceNode = (node) => {
    if (!node || node.nodeType !== 1) return false;
    return node.matches?.('.price__calculated') || !!node.querySelector?.('.price__calculated');
  };

  const contentObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const addedNode of mutation.addedNodes) {
          if (hasDynamicPriceNode(addedNode)) {
            refreshDynamicPrices();
            return;
          }
        }
      }
    }
  });

  contentObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  const observeCartBubble = () => {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const bubbleObserver = new MutationObserver(() => {
      refreshDynamicPrices();
    });

    bubbleObserver.observe(bubble, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
      attributeFilter: ['data-items'],
    });
  };

  observeCartBubble();

  document.addEventListener('cart:updated', refreshDynamicPrices);
  document.addEventListener('announcement-bar:updated', refreshDynamicPrices);
});

// reload cart nosto recomandations

let alreadyUpdatingCartRec = false;

function mirrorDrawerRecosToCartPage(nostoDrawerClass) {
  const drawerNode = document.querySelector(`cart-drawer ${nostoDrawerClass}`);
  if (!drawerNode) return;

  let parent = null;
  document.querySelectorAll('.cart-table-wrapper.drawer-sugest').forEach((n) => {
    if (!n.closest('cart-drawer')) {
      parent = n.parentElement;
      n.remove();
    }
  });
  if (!parent) return;

  const clone = drawerNode.cloneNode(true);
  clone.classList.remove('is-empty');
  // Drop the Nosto placement class so the cart-page copy is NOT a second element
  // matching the drawer selector. Otherwise Nosto's "Replace" (which fills only one
  // element per class) may target this clone instead of the drawer, leaving the
  // drawer empty. Styling is wrapper / .drawer-sugest based, so it stays intact.
  clone.classList.remove(nostoDrawerClass.slice(1));
  parent.appendChild(clone);
}

function reloadCartRecomandations() {
  const isHiddenSale = document.cookie.indexOf('hiddenSale=true') !== -1;

  // Class swaps run immediately so the sample-sale placements are correct.
  if (isHiddenSale) {
    document.querySelectorAll('.drawer-suggest-with-nosto-back-to-school').forEach(function (el) {
      el.classList.remove('drawer-suggest-with-nosto-back-to-school');
      el.classList.add('drawer-suggest-with-nosto-v2-sample-sale');
    });
    document.querySelectorAll('.cart-suggest-with-nosto-v3').forEach(function (el) {
      el.classList.remove('cart-suggest-with-nosto-v3');
      el.classList.add('cart-suggest-with-nosto-v3-sample-sale');
    });
  }

  if (alreadyUpdatingCartRec) return;
  alreadyUpdatingCartRec = true;

  const nostoDrawerClass = isHiddenSale ? '.drawer-suggest-with-nosto-v2-sample-sale' : '.drawer-suggest-with-nosto-v2';

  if (document.querySelector(nostoDrawerClass)) {
    if (window.location.href.includes('/cart')) {
      let mirrorTries = 0;
      const mirrorTimer = setInterval(() => {
        mirrorTries++;
        const drawerNode = document.querySelector(`cart-drawer ${nostoDrawerClass}`);
        const filled = drawerNode && drawerNode.querySelector('.product-grid .grid__item');
        if (filled || mirrorTries >= 12) {
          clearInterval(mirrorTimer);
          mirrorDrawerRecosToCartPage(nostoDrawerClass);
          if (typeof okeWidgetApi !== 'undefined') okeWidgetApi.initAllWidgets();
          showDynamicPrices();
        }
      }, 400);
    } else {
      nostojs(api => {
        api.loadRecommendations();
        setTimeout(() => {
          showDynamicPrices();
          if (typeof okeWidgetApi !== 'undefined') okeWidgetApi.initAllWidgets();
        }, 500);
      });
    }
  }

  alreadyUpdatingCartRec = false;
  showDynamicPrices();
}

// END reload cart nosto recomandations

// polly pocket cursor doll

// add-to-cart / notify-me buttons: the doll hops on desktop, a star burst plays on touch
const POLLY_ATC_SELECTOR = '.product-form__submit, .quick-add__submit, .product-layering__add-to-cart, .item-atc, button[name="add"], .js-back-in-stock, .bis-prev';
const POLLY_STAR_COLORS = ['#a48cf0', '#f3a0c8', '#ffd96b', '#8fd3c9', '#c9a7ff'];

// Spawns a handful of small stars inside `container` (which must be positioned) and removes them when done.
// `spread` is the arc in radians the stars fly out over, centred straight up; 2*PI is a full ring.
function pollyStarBurst(container, { count = 6, spread = Math.PI * 1.4, minDist = 34, maxDist = 64 } = {}) {
  for (let i = 0; i < count; i++) {
    const star = document.createElement('span');
    star.className = 'polly-pocket_click-doll__star';
    const angle = (-Math.PI / 2) + (Math.random() - 0.5) * spread;
    const dist = minDist + Math.random() * (maxDist - minDist);
    star.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
    star.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
    star.style.setProperty('--rot', `${(Math.random() - 0.5) * 240}deg`);
    star.style.setProperty('--size', `${7 + Math.random() * 7}px`);
    star.style.setProperty('--color', POLLY_STAR_COLORS[i % POLLY_STAR_COLORS.length]);
    star.addEventListener('animationend', () => star.remove(), { once: true });
    container.appendChild(star);
  }
}

// Touch devices: no doll, just a subtle ring of stars from the point you tapped an add-to-cart / notify-me button.
function pollyPocketTapBurst() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let lastBurst = 0;

  document.addEventListener('pointerup', (e) => {
    if (e.pointerType === 'mouse') return;   // desktop mouse clicks are handled by the cursor doll
    if (!(e.target instanceof Element) || !e.target.closest(POLLY_ATC_SELECTOR)) return;
    const now = performance.now();
    if (now - lastBurst < 250) return;
    lastBurst = now;

    const burst = document.createElement('span');
    burst.className = 'polly-pocket_tap-burst';
    burst.style.left = `${e.clientX}px`;
    burst.style.top = `${e.clientY}px`;
    document.body.appendChild(burst);
    pollyStarBurst(burst, { count: 8, spread: Math.PI * 2, minDist: 26, maxDist: 52 });
    // the stars remove themselves; drop the wrapper once the last one is gone
    setTimeout(() => burst.remove(), 900);
  }, { passive: true });
}

function pollyPocketCursorLogic() {

  if (window.innerWidth < 768) {
    return
  }
  // show random doll
  let handles_list = ['marshmallow-mood', 'pistachio-swirl', 'berry-daydream'];

  let randomHandle = handles_list[Math.floor(Math.random() * handles_list.length)];
  if (location.href.includes('daydream')) {
    randomHandle = handles_list[2]
  }
  else if (location.href.includes('swirl')) {
    randomHandle = handles_list[1]
  }
  else if (location.href.includes('llow-mood')) {
    randomHandle = handles_list[0]
  }

  document.body.classList.add(`polly-cursor_${randomHandle}`)

  // cursor companion: the doll trails the pointer with a bit of weight,
  // leans into her direction of travel, bobs while running and hops on click.

  const doll = document.querySelector('.polly-pocket_click-doll');
  if (!doll) return;
  const figure = doll.querySelector('.polly-pocket_click-doll__figure');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Offset coordinates (pixels to the right and down from the cursor point)
  const offsetX = 18;
  const offsetY = 14;
  // when the pointer is over a text field she steps further aside so she doesn't cover the typing
  const asideOffsetX = 44;
  const asideOffsetY = 30;

  // what she reacts to (mirrors the elements the Polly cursor icon already targets)
  const CARD_SELECTOR = '.card, .card-wrapper, .product-card-featured_container, .promo-card-it-factor, .promo-card-mgk';
  const CTA_SELECTOR = '.button, .quick-add__submit, .product-form__submit, .shopify-payment-button__button, button[type="submit"], .polly-doll_button';
  const INPUT_SELECTOR = 'input, textarea, select, [contenteditable="true"], .field__input, .search__input';
  const OVERLAY_SELECTOR = 'cart-drawer, cart-notification, modal-dialog, product-modal, quick-add-modal, details-modal, dialog, [role="dialog"], .predictive-search, .menu-drawer, .cart-drawer';

  // idle timings
  const IDLE_FIDGET_MS = 4000;
  const IDLE_HIDE_MS = 10000;

  // tuning
  const FOLLOW_TAU = 0.11;      // seconds for the doll to close ~63% of the gap to the pointer
  const LEAN_PER_PX_S = 0.022;  // degrees of lean per px/s of horizontal speed
  const LEAN_MAX = 16;          // degrees
  const LEAN_STIFFNESS = 140;   // spring toward the target lean
  const LEAN_DAMPING = 14;      // pendulum settle
  const BOB_MAX_PX = 5;         // footstep bounce height at full speed
  const BOB_FULL_SPEED = 900;   // px/s at which the bob reaches full height
  const STEPS_PER_SECOND = 5;

  const target = { x: 0, y: 0 };
  const pos = { x: 0, y: 0 };
  let lean = 0, leanVelocity = 0;
  let bobAmp = 0, bobPhase = 0;
  let lastFrame = 0, rafId = 0, started = false;

  function frame(now) {
    const dt = Math.min((now - lastFrame) / 1000, 0.05) || 0.016;
    lastFrame = now;

    // 1. follow with lag
    const k = 1 - Math.exp(-dt / FOLLOW_TAU);
    const prevX = pos.x, prevY = pos.y;
    pos.x += (target.x - pos.x) * k;
    pos.y += (target.y - pos.y) * k;
    const vx = (pos.x - prevX) / dt;
    const vy = (pos.y - prevY) / dt;
    const speed = Math.hypot(vx, vy);

    // 2. lean into the direction of travel, settle like a pendulum
    const targetLean = Math.max(-LEAN_MAX, Math.min(LEAN_MAX, vx * LEAN_PER_PX_S));
    leanVelocity += ((targetLean - lean) * LEAN_STIFFNESS - leanVelocity * LEAN_DAMPING) * dt;
    lean += leanVelocity * dt;

    // 3. footstep bob while moving, fades out when she stops
    const wantedAmp = Math.min(speed / BOB_FULL_SPEED, 1) * BOB_MAX_PX;
    bobAmp += (wantedAmp - bobAmp) * Math.min(dt * 10, 1);
    bobPhase += dt * Math.PI * 2 * STEPS_PER_SECOND;
    const bob = Math.abs(Math.sin(bobPhase)) * bobAmp;

    doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
    figure.style.transform = `translateY(${-bob}px) rotate(${lean}deg)`;

    const settled = Math.abs(target.x - pos.x) < 0.3 && Math.abs(target.y - pos.y) < 0.3
      && Math.abs(lean) < 0.05 && Math.abs(leanVelocity) < 0.5 && bobAmp < 0.05;
    if (settled) {
      pos.x = target.x; pos.y = target.y; lean = 0; leanVelocity = 0; bobAmp = 0;
      doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
      figure.style.transform = '';
      rafId = 0;
      return;
    }
    rafId = requestAnimationFrame(frame);
  }

  let fidgetTimer = 0, hideTimer = 0;

  function setState(name, on) {
    doll.classList.toggle(name, on);
  }

  function goIdle() {
    setState('is-idle', true);
  }

  function hide() {
    setState('is-idle', false);
    setState('is-active', false);
  }

  window.addEventListener('mousemove', (e) => {
    const el = e.target instanceof Element ? e.target : null;
    const overOverlay = !!(el && el.closest(OVERLAY_SELECTOR));
    const overInput = !overOverlay && !!(el && el.closest(INPUT_SELECTOR));
    const overCta = !overOverlay && !overInput && !!(el && el.closest(CTA_SELECTOR));
    const overCard = !overOverlay && !overInput && !overCta && !!(el && el.closest(CARD_SELECTOR));

    target.x = e.clientX + (overInput ? asideOffsetX : offsetX);
    target.y = e.clientY + (overInput ? asideOffsetY : offsetY);

    if (!started) {
      // first move: appear where the pointer is instead of flying in from the corner
      started = true;
      pos.x = target.x; pos.y = target.y;
      doll.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0)`;
    }

    // stay out of the way of the cart drawer, modals and the search dropdown
    clearTimeout(fidgetTimer);
    clearTimeout(hideTimer);
    setState('is-idle', false);
    setState('is-active', !overOverlay);

    if (reducedMotion) {
      doll.style.transform = `translate3d(${target.x}px, ${target.y}px, 0)`;
      return;
    }

    setState('is-over-input', overInput);
    setState('is-over-cta', overCta);
    setState('is-over-card', overCard);

    if (!overOverlay) {
      fidgetTimer = setTimeout(goIdle, IDLE_FIDGET_MS);
      hideTimer = setTimeout(hide, IDLE_HIDE_MS);
    }

    if (!rafId) {
      lastFrame = performance.now();
      rafId = requestAnimationFrame(frame);
    }
  });

  // fade out when the pointer leaves the window, back on the next move
  document.addEventListener('mouseleave', () => {
    clearTimeout(fidgetTimer);
    clearTimeout(hideTimer);
    hide();
  });

  // 4. add-to-cart click: squash while held, hop + star burst on release
  if (reducedMotion) return;

  let lastBurst = 0;

  function burst() {
    const now = performance.now();
    if (now - lastBurst < 250) return;   // don't pile up stars on rapid clicks
    lastBurst = now;
    pollyStarBurst(doll);   // mostly upward, from her feet
  }

  window.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    if (!(e.target instanceof Element) || !e.target.closest(POLLY_ATC_SELECTOR)) return;
    doll.classList.remove('is-hopping');
    doll.classList.add('is-pressed');
  });

  window.addEventListener('mouseup', (e) => {
    if (e.button !== 0 || !doll.classList.contains('is-pressed')) return;
    doll.classList.remove('is-pressed');
    // restart the hop animation even if the previous one is still running
    void doll.offsetWidth;
    doll.classList.add('is-hopping');
    burst();
  });

  doll.addEventListener('animationend', (e) => {
    if (e.target.tagName === 'IMG') doll.classList.remove('is-hopping');
  });
}

function pollyPocketSearchButtons() {
  const searchInput = document.querySelector('#predictive-search__header .search__input');
  const toolbar = document.querySelector('.polly-pocket_search_buttons');
  if (!searchInput || !toolbar) return;
  // the <details> that opens/closes the search modal; on mobile the dolls are shown whenever it is open
  const searchDetails = toolbar.closest('details');
  const isMobile = () => window.innerWidth <= 768;

  const redirectBtns = document.querySelector('.polly-pocket_redirect-btns');
  if (redirectBtns) {
    redirectBtns.addEventListener('click', (e) => {
      const btn = e.target.closest('.redirect-btn[data-handle]');
      if (!btn) return;
      location.href = `${Shopify.routes.root}products/${btn.dataset.handle}`;
    });
  }

  let savedScrollY = 0;
  let inputWasFocused = false;

  function preventTouchScroll(e) {
    if (e.target === searchInput || e.target.closest('.search-modal')) return;
    e.preventDefault();
  }

  function lockScroll() {
    savedScrollY = window.scrollY;
    document.documentElement.classList.add('scroll-locked');
    document.body.classList.add('scroll-locked');
    window.addEventListener('touchmove', preventTouchScroll, { passive: false });
  }



  function unlockScroll() {
    document.documentElement.classList.remove('scroll-locked');
    document.body.classList.remove('scroll-locked');
    window.removeEventListener('touchmove', preventTouchScroll);
    window.scrollTo(0, savedScrollY);
  }

  // remember whether the keyboard was up when a doll is tapped, so we only keep it up if it already was
  toolbar.addEventListener('pointerdown', () => {
    inputWasFocused = document.activeElement === searchInput;
  });

  toolbar.addEventListener('click', (e) => {
    e.preventDefault();
    if (isMobile() && inputWasFocused) {
      searchInput.focus();
    }

    const button = e.target.closest('.polly-pocket_search_button[data-handle]');
    if (!button) return;
    const handle = button.dataset.handle;

    if (e.target.closest('.redirect-btn')) {
      location.href = `${Shopify.routes.root}products/${handle}`;
      return;
    }

    const wasOpen = toolbar.classList.contains(`${handle}-clicked`);
    // on touch, tapping the doll that is already up puts her back down; on desktop hover keeps her up
    if (wasOpen && isMobile()) {
      lowerDolls();
      return;
    }
    raiseDoll(handle);
    raisedByTyping = false;
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let raisedByTyping = false;

  function lowerDolls() {
    const activeClasses = [...toolbar.classList].filter(className => className.includes('clicked'));
    toolbar.classList.remove(...activeClasses);
  }

  function raiseDoll(handle) {
    const clickedClass = `${handle}-clicked`;
    if (toolbar.classList.contains(clickedClass)) return;
    lowerDolls();
    toolbar.classList.add(clickedClass);
  }

  // react to what is typed: a doll pops up when her name (or the collection) is in the search text
  const DOLL_KEYWORDS = [
    { handle: 'marshmallow-mood', words: ['marshmallow', 'mood', 'polly', 'pocket'] },
    { handle: 'pistachio-swirl', words: ['pistachio', 'swirl'] },
    { handle: 'berry-daydream', words: ['berry', 'daydream'] },
  ];
  let typingTimer = 0;
  searchInput.addEventListener('input', () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      const text = searchInput.value.trim().toLowerCase();
      const match = text.length >= 3
        ? DOLL_KEYWORDS.find(d => d.words.some(w => text.includes(w)))
        : null;
      if (match) {
        raiseDoll(match.handle);
        raisedByTyping = true;
      } else if (raisedByTyping) {
        // only lower her if typing was what raised her; a tapped doll stays up
        lowerDolls();
        raisedByTyping = false;
      }
    }, 150);
  });

  // hover logic (desktop only: touch browsers fire a synthetic mouseover before each tap,
  // which would raise the doll and let the tap's click immediately put her back down)
  const canHover = window.matchMedia('(hover: hover)');
  toolbar.addEventListener('mouseover', (e) => {
    if (isMobile() || !canHover.matches) return;
    if (e.target.closest('.redirect-btn')) return;
    if (e.target.closest('.polly-pocket_search_button[data-handle]')) e.target.click();
  });

  // Mobile: the dolls sit at the bottom of the screen for as long as the search modal is open.
  // When the keyboard is up they ride on top of it; when it is down they rest on the bottom edge.
  function togglePollyButtons() {
    if (!isMobile()) return;

    const modalOpen = !searchDetails || searchDetails.open;
    if (!modalOpen) {
      lowerDolls();
      raisedByTyping = false;
      toolbar.style.display = 'none';
      toolbar.style.transform = 'translateY(0px)';
      return;
    }

    toolbar.style.display = 'flex';
    toolbar.style.transform = 'translateY(0px)';
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', togglePollyButtons);
    window.visualViewport.addEventListener('scroll', togglePollyButtons);
  }
  if (searchDetails) {
    searchDetails.addEventListener('toggle', togglePollyButtons);
    searchDetails.addEventListener('toggle', () => {
      if (!searchDetails.open) {
        lowerDolls();
        raisedByTyping = false;
      }
    });
  }
  window.addEventListener('resize', togglePollyButtons);

  searchInput.addEventListener('focus', () => {
    if (window.innerWidth <= 768) {
      lockScroll();
      togglePollyButtons()
    }
    else {
      toolbar.style.display = 'flex';
    }
  });

  searchInput.addEventListener('blur', () => {
    setTimeout(() => {
      if (document.activeElement !== searchInput) {
        if (isMobile()) {
          unlockScroll();
          togglePollyButtons();   // keyboard is gone: drop the dolls back to the bottom edge, keep them visible
        }
      }
    }, 100);
  });

  document.addEventListener('click', (e) => {
    function setInteractiveWidget(enable = true) {
      const meta = document.querySelector('meta[name="viewport"]');
      if (!meta) return;

      const baseContent = 'width=device-width,initial-scale=1';

      meta.content = enable
        ? `${baseContent},interactive-widget=resizes-content`
        : baseContent;
    }
    if (window.innerWidth <= 768) {
      if (e.target.closest('.bottom-island__search-btn')) {
        setInteractiveWidget(true)
      }
      else if (e.target.closest('.search-modal__close-button')) {
        setInteractiveWidget(false)
      }
    }
  })
}

window.addEventListener("DOMContentLoaded", (e) => {
  pollyPocketSearchButtons();
  pollyPocketCursorLogic();
  pollyPocketTapBurst();
})
// END polly pocket